// extracted by mini-css-extract-plugin
export default {"infoDialog":"m7mBu4O0wBUX4y2j6efU","infoDialogBtn":"SGCm1v76aRkYWREmGteF"};